<template>
  <div class="serveUseApplyDetail">
    <!-- 0:未认证 1:已通过 2:认证中 3:已驳回 -->
    <Alert v-if="authInfo.status == 3" show-icon type="error">
      <span style="color: #f56c6c">
        已驳回
        <span class="ml-32 lineBreak">原因：{{ authInfo.rejectCause }}</span>
      </span>
    </Alert>
    <div class="serveUseApplyDetail-main mt-24">
      <div class="serveUseApplyDetail-main-left">
        <p class="font16 fontbig">基本信息</p>
        <div class="divider_line mt-16 mb-24"></div>
        <div class="userImg">
          <img
            v-if="userInfo.avatar"
            :src="userInfo.avatar"
            alt
            @click="previewPicture(userInfo.avatar)"
          />
          <!-- 如果用户没有更换过头像，则后端不会返回头像的url，此处头像与应用中心默认头像保持一致即可 -->
          <img v-if="!userInfo.avatar" src="~@/assets/img/default_avatar.png" />
        </div>
        <div class="infokv">
          <label>账号名：</label>
          <div>{{ userInfo.account || "暂未设置账号" }}</div>
        </div>
        <div class="infokv">
          <label>注册时间：</label>
          <div>{{ userInfo.createTime }}</div>
        </div>
        <div class="infokv">
          <label>手机号码：</label>
          <div>{{ userInfo.phone?userInfo.phone:'暂未绑定手机号' }}</div>
        </div>
        <!-- 如果该用户没有绑定邮箱则不显示 -->
        <div class="infokv">
          <label>注册邮箱：</label>
          <div v-if="userInfo.email">{{ userInfo.email }}</div>
          <div v-if="!userInfo.email">暂未绑定邮箱</div>
        </div>
        <p class="font16 fontbig">认证信息</p>
        <div class="divider_line mt-16 mb-24"></div>
        <div>
          <div class="infokv flexfs">
            <label class="label10">营业执照：</label>
            <div>
              <img :src="authInfo.license" class="w180px" @click="previewPicture(authInfo.license)" />
            </div>
          </div>
          <div class="infokv">
            <label class="label10">{{companyName}}</label>
            <div>{{ authInfo.name }}</div>
          </div>
          <div class="infokv">
            <label class="label10">统一社会信用代码：</label>
            <div>{{ authInfo.creditCode }}</div>
          </div>
          <div class="infokv" v-if="authInfo.type == 0">
            <label class="label10">经营限制：</label>
            <div>{{ operatingPeriod }}</div>
          </div>
          <div class="infokv">
            <label class="label10">所在地：</label>
            <div>{{ province }}{{ city }} {{ district }} {{ authInfo.address }}</div>
          </div>
          <div class="infokv">
            <label class="label10">法定代表人姓名：</label>
            <div>{{ authInfo.legal }}</div>
          </div>
          <div class="infokv">
            <label class="label10">法定代表人身份证号：</label>
            <div>{{ authInfo.legalIdentity }}</div>
          </div>
          <div class="infokv" v-if="authInfo&&authInfo.identity==1">
            <label class="label10">被授权人姓名：</label>
            <div>{{ authInfo.certigier }}</div>
          </div>
          <div class="infokv" v-if="authInfo&&authInfo.identity==1">
            <label class="label10">被授权人身份证号：</label>
            <div>{{ authInfo.certigierIdentity }}</div>
          </div>
          <div class="infokv flexfs" v-if="authInfo&&authInfo.identity==1">
            <label class="label10">授权委托书：</label>
            <div>
              <img
                :src="authInfo.authorization"
                class="w180px"
                @click="previewPicture(authInfo.authorization)"
              />
            </div>
          </div>
          <div class="infokv">
            <label class="label10">联系人：</label>
            <div>{{ authInfo.contact }}</div>
          </div>
          <div class="infokv">
            <label class="label10">联系电话：</label>
            <div>{{ authInfo.phone }}</div>
          </div>
          <div class="infokv">
            <label class="label10">邮箱：</label>
            <div>{{ authInfo.email }}</div>
          </div>
          <div class="ml-140">
            <!-- 审核通过 -->
            <Poptip
              class="poptip"
              confirm
              transfer
              placement="top"
              @on-ok="checkPass"
              @on-cancel="cancelCheckPass"
              title="确认通过审核吗？"
            >
              <Button
                shape="circle"
                class="w104px mr-24"
                type="primary"
                v-show="authInfo.status == 2"
              >审核通过</Button>
            </Poptip>

            <Button
              shape="circle"
              class="w104px mr-24"
              type="error"
              v-show="authInfo.status == 2"
              @click="rejectConfirm"
            >驳回</Button>
            <Button shape="circle" class="w104px" @click="back">返回</Button>
          </div>
        </div>
      </div>
      <!-- 0:未认证 1:已通过 2:认证中 3:已驳回 -->
      <div class="serveUseApplyDetail-main-right" v-if="commitList && commitList.length">
        <div class="top"></div>
        <div class="commitlist">
          <div class="commititem mb-16" v-for="(item, index) in commitList" :key="index">
            <div class="flexsb">
              <div>
                <p v-if="item.status != 3">第{{ item.submitMsg }}次提交</p>
                <p v-if="item.status == 3">已驳回</p>

                <p class="mt-4">{{ item.createTime || "暂无" }}</p>
              </div>
              <div>
                <img src="@/assets/img/video/commit_item.png" alt />
              </div>
            </div>
            <div
              v-if="item.status == 3"
              class="reason mt-16 pt-16 lineBreak"
            >原因：{{ item.rejectCause || "无原因" }}</div>
          </div>
        </div>
      </div>
    </div>
    <rejectApply
      v-if="showReject"
      @close="showReject = false"
      @confirm="showReject = false"
      :formId="returnId"
    />
    <!-- 预览大图 -->
    <previewImage v-if="preViewModal" v-model="preViewModal" :preView="preView" />
  </div>
</template>

<script>
import { getServeUserCheckDetail, serveUserCheckPass } from "@/api/serviceUse";
import { CodeToText } from "element-china-area-data";
import previewImage from "@/components/previewImage"; //预览大图组件

import rejectApply from "../components/apply/RejectApply";
export default {
  name: "",
  components: {
    rejectApply,
    previewImage
  },
  data() {
    return {
      province: "",
      city: "",
      district: "",
      showReject: false,
      userInfo: {},
      authInfo: {},
      id: "",
      loading: false,
      delLoad: false,
      showDetail: false,
      commitList: [],
      rowData: {},
      returnId: "",
      //预览大图
      preViewModal: false, //预览弹窗
      preView: {
        imgSrc: "", //预览图片路径
        title: "" //预览图片标题
      }
    };
  },
  created() {
    this.id = this.$route.query.id;
    console.log("id", this.id);
    this.getInfo();
  },
  computed: {
    companyName() {
      if (this.authInfo.type == 0) {
        return "企业名称：";
      } else if (this.authInfo.type == 1) {
        return "政府/单位名称：";
      } else {
        return "组织名称：";
      }
    },
    operatingPeriod() {
      if (this.authInfo.type == "0") {
        if (this.authInfo.isLongTerm == "1") {
          return "长期";
        } else {
          if (this.authInfo.isLongTerm == "0") {
            return (
              this.authInfo.operatingPeriodBegin.split(" ")[0] +
              "至" +
              this.authInfo.operatingPeriodEnd.split(" ")[0]
            );
          }
        }
      }
    }
  },
  methods: {
    previewPicture(src) {
      this.preView.imgSrc = src;
      this.preViewModal = true;
    },
    //获取服务使用者详情
    getInfo() {
      getServeUserCheckDetail(this.id)
        .then(res => {
          console.log(res, "服务使用者详情");
          this.userInfo = res.data.data.sacUser;
          this.authInfo = res.data.data.company;
          this.commitList = res.data.data.historyList;
          this.province = this.authInfo.provinceName;
          this.city = this.authInfo.cityName;
          this.district = this.authInfo.districtName;
          console.log("province", this.province);
        })
        .catch(err => {
          console.log("接口请求错误");
        });
    },
    rejectConfirm() {
      console.log("驳回理由");
      this.returnId = this.authInfo.id + "";
      this.showReject = true;
    },
    // 返回上一级
    back() {
      this.$router.go(-1);
    },
    // 审核通过
    checkPass() {
      // 认证审核通过
      serveUserCheckPass(this.authInfo.id)
        .then(res => {
          console.log("res认证审核通过", res);
          this.$Message.success("认证审核通过");
          this.$router.push({ path: "/serveUse/serveUseChecklist" });
        })
        .catch(err => {
          console.log(err, "err");
        });
    },
    // 取消审核通过
    cancelCheckPass() {
      console.log("点击了取消按钮");
    },
    link(path, type) {
      if (type) {
        this.$router.push({
          path: path,
          query: {
            id: this.userInfo.id,
            type: type
          }
        });
      } else {
        this.$router.push({
          path: path
        });
      }
    }
  }
};
</script>

<style lang="scss">
.serveUseApplyDetail {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 24px 32px;
  overflow: auto;
  &-alert {
    color: #e6a23c;
  }
  &-main {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;
    &-left {
      width: calc(100% - 380px);
      height: 100%;
      .userImg {
        width: 124px;
        height: 124px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
    }
    &-right {
      width: 364px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      height: 100%;
      overflow: auto;
      > .top {
        height: 118px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #dcdfe6;
        padding: 24px;
        background-image: url("~@/assets/img/video/commit_img.png");
        background-repeat: no-repeat;
        background-size: 100%;
        .line {
          width: 32px;
          height: 2px;
          background: #3c8aff;
        }
      }
      > .commitlist {
        padding: 16px 24px;
        height: calc(100% - 118px);
        .commititem {
          width: 100%;
          padding: 12px 24px;
          background: rgba(220, 223, 230, 0.1);
          border: 1px dashed #dcdfe6;
          border-radius: 4px;
          .reason {
            border-top: 1px solid rgba(246, 247, 249, 1);
          }
        }
      }
      > .commitlist div:last-child {
        margin-bottom: 0px;
      }
    }
  }
  //空格代表后代选择器
  .serveUseApplyDetail-main-left :first-child {
    margin-top: 0px;
  }
}
</style>
